/*
 * Fila de tarjetas semáforo (verde/amarillo/rojo) con conteo y valor, clickables.
 * Usa los tokens de estado del codekit (success/warning/error).
 */
import { Box, Description, Flexbox, Heading, Stack } from "codekit";

import { bucketLabels, bucketTokens, fmtCOP } from "./utils/carthelp";

const SEGMENTS = ["verde", "amarillo", "rojo"];

/**
 * Renderiza las tres tarjetas semáforo de un grupo
 * @param {Object} props Propiedades del componente
 * @param {Object} props.groups Mapa { verde, amarillo, rojo } con { count, valor }
 * @param {Function} props.onCardClick Callback con el rango al hacer click
 */
const Semcards = ({ groups, onCardClick }) => {
  const bClickable = typeof onCardClick === "function";

  return (
    <Flexbox gap={4} wrap>
      {SEGMENTS.map((sSeg) => (
        <Box
          key={sSeg}
          bg={bucketTokens[sSeg]}
          rounded="lg"
          spacing={5}
          onClick={bClickable ? () => onCardClick(sSeg) : undefined}
          style={{ flex: 1, minWidth: 200, cursor: bClickable ? "pointer" : "default" }}
        >
          <Stack gap={1}>
            <Description variant="description-3" color="white">
              {bucketLabels[sSeg]}
            </Description>
            <Heading variant="heading-4" color="white">
              {groups[sSeg].count} DO
            </Heading>
            <Description variant="description-2" color="white">
              {fmtCOP(groups[sSeg].valor)}
            </Description>
          </Stack>
        </Box>
      ))}
    </Flexbox>
  );
};

export default Semcards;
